const Path = Object.freeze({
  CHECKLISTS: "/checklist",
  CHECKLIST: "/checklist/:uuid",
});

export { Path };
